import { useEffect } from "react";

const NPS = () => {
  const WRITE_KEY = "0okOoNSyTFROpemW3PI9xd100kurCPmE";

  useEffect(() => {
    // Satismeter 스크립트 로드
    const loadSatisMeter = () => {
      console.log("Loading Satismeter script...");
      window.satismeter =
        window.satismeter ||
        function () {
          (window.satismeter.q = window.satismeter.q || []).push(arguments);
        };
      window.satismeter.l = 1 * new Date();

      const script = document.createElement("script");
      script.async = true;
      script.src = "https://app.satismeter.com/js";
      script.onload = () => {
        console.log("Satismeter script loaded.");
      };
      document.body.appendChild(script);

      // Satismeter 초기화
      window.satismeter({
        writeKey: WRITE_KEY,
      });
    };

    loadSatisMeter();

    // 컴포넌트 언마운트 시 정리
    return () => {
      console.log("Cleaning up Satismeter script...");
      // Satismeter 스크립트 제거
      const script = document.querySelector(
        'script[src="https://app.satismeter.com/js"]'
      );
      if (script) {
        script.remove();
        console.log("Satismeter script removed.");
      }
      // window 객체에서 satismeter 제거
      delete window.satismeter;
      console.log("Satismeter removed from window object.");
    };
  }, []); // 의존성 배열이 비어있음 (writeKey가 상수이므로)

  return null; // 이 컴포넌트는 UI를 렌더링하지 않습니다
};

export default NPS;
